import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SummaryFieldModule} from "../../../../../core/component/summary-field/summary-field.module";
import {DocumentSummaryModelFieldComponent} from "./document-summary-field.component";
import {DocumentDownloadModule} from '../document-download/document-download.module';
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";
import {
    PriceSummaryFieldModule
} from "../../../../../common/price/api/component/price-summary-field/price-summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryFieldModule,
        DocumentDownloadModule,
        LoadingModule,
        PriceSummaryFieldModule,
    ],
    declarations: [
        DocumentSummaryModelFieldComponent,
    ],
    exports: [
        DocumentSummaryModelFieldComponent
    ]
})
export class DocumentSummaryModelFieldModule {
}
